import { ContentNode } from '@helo/cms'

export const TypeRendererParts = {
  isValuePending: (
    contentNode: ContentNode | null | undefined,
    isLoading?: boolean,
  ) => {
    if (isLoading) {
      return true
    }

    if (!contentNode) {
      return false
    }

    if (contentNode.kind === 'FIELD') {
      return TypeRendererParts.isValuePending(contentNode.ofType, false)
    }

    return false
  },
}
